import { useContext } from 'react';
import { useRouteMatch } from 'react-router-dom';
import {
  DetailContext,
  DetailHandle,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { RedirectForm, useRedirect } from '@composite/redirect/dialog-redirect';
import { EsFile, SprFile } from '@models';
import { EsFileState, EvidenceApiUrl, EvidenceBrowserUrl } from '@enums';
import { useFormFields } from './change-state-dialog';
import { getOptions } from './change-state-utils';

export function useChangeStateDialog() {
  const match = useRouteMatch();

  const { source } = useContext<DetailHandle<SprFile>>(DetailContext);

  const inAllFiles = [
    EvidenceBrowserUrl.ES_FILES_ALL + '/:id?',
    EvidenceBrowserUrl.ES_FILES_SEARCH + '/:id?',
  ].includes(match.path);

  const callApi = useEventCallback(
    (id: string, formData: { state: EsFileState }) =>
      abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/${id}/state/${formData.state}`,
        {
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          method: 'PUT',
        }
      )
  );

  const showButton =
    source?.data?.state &&
    ![
      EsFileState.CLOSED,
      // EsFileState.IN_PROGRESS,
      EsFileState.SHREDDED,
    ].includes(source.data?.state);

  const FormFields = useFormFields();

  const initialState =
    source.data?.state === EsFileState.NEW
      ? EsFileState.IN_PROGRESS
      : EsFileState.CLOSED;

  const redirectBag = useRedirect<
    EsFile,
    RedirectForm & { state?: EsFileState }
  >({
    options: (values) =>
      getOptions(source.data?.state, values?.state ?? initialState),
    redirectTo: (values) => {
      switch (values?.state) {
        case EsFileState.IN_PROGRESS:
          return EvidenceBrowserUrl.SPR_FILES_IN_PROGRESS;
        case EsFileState.CLOSED:
          return EvidenceBrowserUrl.SPR_FILES_CLOSED;

        default:
          return EvidenceBrowserUrl.ES_FILES_ALL;
      }
    },
    FormFields,
    initialValues: {
      state: initialState,
    },
  });

  return {
    callApi,
    showButton,
    redirectBag: inAllFiles ? { FormFields } : { ...redirectBag },
  };
}
